import { createMachine } from 'xstate';
import { ContractVersion } from '~/typings/context';
import { sendToSegment, getUserIpFromStore } from '~/utils/tracking';
import { contextCreator } from '../utils/context';
import { CalendlyContext, CalendlyDoneData, MeetingScheduledEvent } from './types';

export const calendlyMachine = () =>
  createMachine(
    {
      tsTypes: {} as import('./machine.typegen').Typegen0,
      predictableActionArguments: true,
      schema: {
        context: {} as CalendlyContext,
        events: {} as MeetingScheduledEvent,
      },
      context: {
        errors: {},
        funnelPacket: {} as CalendlyContext['funnelPacket'],
        showLmi: false,
        vnmSolarProjectContracts: [] as ContractVersion[],
      },
      id: 'calendlyMachine',
      initial: 'start',
      states: {
        start: {
          entry: 'trackStarted',
          always: { target: 'review' },
        },
        review: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                SCHEDULE_MEET: [{ target: 'submitting' }],
              },
            },
            submitting: {
              always: { target: '#completed' },
            },
          },
        },
        completed: {
          id: 'completed',
          type: 'final',
          data: (context): CalendlyDoneData => ({
            docuSignContracts: context.docuSignContracts,
            vnmSolarProjectContracts: context.vnmSolarProjectContracts,
            lmiStatus: context.lmiStatus,
          }),

          entry: 'trackCompleted',
        },
      },
    },
    {
      actions: {
        /* eslint-disable camelcase */
        trackCompleted: context => {
          const userIp = getUserIpFromStore();
          sendToSegment({
            type: 'calendly_step_completed',
            funnelPacket: context.funnelPacket,
            userIp,
            promo_code: context.funnelPacket?.user?.promoCode,
          });
        },
        trackStarted: context => {
          const userIp = getUserIpFromStore();
          sendToSegment({
            type: 'calendly_step_started',
            funnelPacket: context.funnelPacket,
            userIp,
            promo_code: context.funnelPacket?.user?.promoCode,
          });
        },
        /* eslint-enable camelcase */
      },
    },
  );

export const calendlyContext = contextCreator<CalendlyContext, 'funnelPacket'>(calendlyMachine);
